import { modules } from '../../data/modules.jsx';

export default function Modulos() {
  return (
    <div className="section" id="modulos">
      <div style={{ marginBottom: 52 }} data-stagger="80">
        <div className="section-label r">Qué aprenderás</div>
        <h2 className="section-title r">Módulos de aprendizaje</h2>
        <p className="section-sub r">
          Contenido práctico, creado por profesionales que viven de lo que enseñan.
        </p>
      </div>
      <div className="modules-grid" data-stagger="80">
        {modules.map((m) => (
          <div className="module-card r" key={m.number}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className="module-icon">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {m.icon}
                </svg>
              </div>
              <span className="module-number">{m.number}</span>
            </div>
            <div className="module-name">{m.name}</div>
            <div className="module-desc">{m.desc}</div>
            <span className="module-tag">{m.tag}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
